// Unauthorized.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  // Function to go back one step
  const goBack = () => {
   // navigate(-1); // Navigate one step back in history
   navigate("/dashboard")
  };

  return (
    <div className=" text-center mt-5">
      <div className="alert alert-danger">
        <h1>403 - Unauthorized</h1>
        <p>You do not have permission to access this page.</p>
      </div>

      <button className="btn btn-primary mt-3" onClick={goBack}>
        Go to Home
      </button>
    </div>
  );
};

export default Unauthorized;
